import { H3 } from '@/components/label/H3'

interface Props {
  important: string[]
}
export const Important: React.FC<Props> = ({ important }) => {
  return (
    <>
      <H3 title="本書の要点" />
      <div className="sm:p-0 px-[10px]">
        <ul className="list-none">
          {important.map((text, index) => {
            return (
              <li
                key={index}
                className={`pb-[14px] mb-[14px] ${
                  index != important.length - 1 &&
                  'border-b border-[#e6e6e6] border-solid'
                }`}
              >
                <span className="inline-block pt-2 mr-2 w-[55px] h-[55px] text-xs leading-5 text-center text-[#34a0ad] align-middle rounded-[50%] border border-[#34a0ad] border-solid">
                  要点
                  <div className="text-[18px]">{index + 1}</div>
                </span>
                <span className="inline-block w-[calc(100%-65px)] sm:w-[640px] align-middle">
                  {text}
                </span>
              </li>
            )
          })}
        </ul>
      </div>
    </>
  )
}
